import styled from 'styled-components'
import { colors } from '../../theme'

export const Container = styled.div`
  color: ${colors.white};
  font-family: 'Sora', sans-serif;
  width: 100%;
`
export const Total = styled.span<{ color: string }>`
  font-size: 20px;
  margin-right: 16px;
  font-weight: 600;
  color: ${({ color }) => color};
`

export const Title = styled.div<{ colorTitle: string }>`
  font-size: 12px;
  margin-bottom: 5px;
  color: ${({ colorTitle }) => colorTitle};
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`
type PercentageProps = {
  isPlus: boolean
}

export const Percentage = styled.span<PercentageProps>`
  font-size: 12px;
  font-family: 'Poppins', sans-serif;
  background-color: ${({ isPlus }) =>
    isPlus ? `${colors.accentBg}` : `${colors.error}`};
  /* Cor propria: sem ela a pilula herdava o branco do Container por acaso.
     Os dois fundos (accentBg e error) carregam branco acima de 4,5:1. */
  color: ${colors.white};
  border-radius: 100px;
  padding: 2px 13px;
`
